// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-item-container[data-v-ef5e9144]{margin-bottom:24px}.video-box[data-v-ef5e9144]{width:100%}.description-box[data-v-ef5e9144]{margin:auto 0;height:100%;padding-left:20px;font-size:30px}", ""]);
// Exports
module.exports = exports;
